import React, { useContext, useEffect } from "react";
import { useHistory } from "react-router-dom";
import UserContext from "../../navigation/context/userContext";
import { useTranslation } from "react-i18next";

// UI Components
import { 
    Box, Typography, Grid, Paper, Container, Avatar, 
    Stack, IconButton, Button, useTheme, alpha 
} from "@mui/material";

// Iconos
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faUser, faTicket, faCalendarAlt, faGifts, 
    faStar, faChevronRight, faIdCard 
} from "@fortawesome/free-solid-svg-icons";

// Componentes y Assets
import Categories from "../website/Categories"; // Tu componente de categorías mejorado abajo
import { imagesURL } from '../../apiRoutes/apiBase'; // Asegúrate de importar esto

// --- COMPONENTE DE TARJETA DE ACCIÓN ---
const ActionCard = ({ title, icon, color, onClick, subtitle }) => {
    const theme = useTheme();
    
    return (
        <Paper
            elevation={0}
            onClick={onClick}
            sx={{
                p: 3,
                height: '100%',
                cursor: 'pointer',
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 4,
                transition: 'all 0.3s ease',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                position: 'relative',
                overflow: 'hidden',
                '&:hover': {
                    borderColor: color,
                    transform: 'translateY(-4px)',
                    boxShadow: `0 10px 20px -10px ${alpha(color, 0.3)}`
                }
            }}
        >
            {/* Círculo decorativo de fondo */}
            <Box sx={{
                position: 'absolute',
                top: -20,
                right: -20,
                width: 100,
                height: 100,
                borderRadius: '50%',
                bgcolor: alpha(color, 0.05),
                zIndex: 0
            }} />

            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2, zIndex: 1 }}>
                <Avatar sx={{ bgcolor: alpha(color, 0.1), color: color, width: 48, height: 48, borderRadius: 2 }}>
                    <FontAwesomeIcon icon={icon} size="lg" />
                </Avatar>
                {/* Flechita discreta */}
                <Box sx={{ color: 'text.disabled' }}>
                    <FontAwesomeIcon icon={faChevronRight} size="xs"/>
                </Box>
            </Box>
            
            <Box sx={{ zIndex: 1 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '1.1rem' }}>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {subtitle}
                </Typography>
            </Box>
        </Paper>
    );
};

export default function ClientHome() {
    const { t } = useTranslation();
    const { userData } = useContext(UserContext);
    const history = useHistory();
    const theme = useTheme();

    const redirect = (route) => history.push(route);

    useEffect(() => {
        window.scrollTo(0, 0);
        console.log(userData.entity.name)
    }, []);

    // Colores para las tarjetas (puedes ajustarlos a tu branding)
    const cardColors = {
        blue: '#2196F3',
        purple: '#9C27B0',
        orange: '#FF9800',
        green: '#4CAF50',
        teal: '#009688'
    };

    return (
        <Box sx={{ p:5 }}>
            {/* --- 1. WELCOME SECTION --- */}
            <Box sx={{ mb: 4 }}>
                <Grid container alignItems="center" spacing={2}>
                    <Grid item>
                        <Avatar 
                            src={userData.user.imagen ? imagesURL + 'users/' + userData.user.imagen : ''} 
                            sx={{ width: 64, height: 64, border: `2px solid ${theme.palette.primary.main}` }}
                        >
                            {userData.entity.name ? userData.entity.name.charAt(0) : 'U'}
                        </Avatar>
                    </Grid>
                    <Grid item>
                        <Typography variant="h4" fontWeight="800" sx={{ letterSpacing: '-0.5px' }}>
                            Hola, {userData.entity.name ? userData.entity.name.split(' ')[0] : 'Usuario'} 👋
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            ¿Qué te gustaría hacer hoy en QUD?
                        </Typography>
                    </Grid>
                </Grid>
            </Box>

            {/* --- 2. QUICK ACTIONS DASHBOARD --- */}
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
                Mi Actividad
            </Typography>
            
            <Grid container spacing={3} sx={{ mb: 6 }}>
                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <ActionCard 
                        title={t('helpers.profile')} 
                        subtitle="Datos personales y seguridad"
                        icon={faUser} 
                        color={cardColors.blue}
                        onClick={() => redirect('profile')}
                    />
                </Grid>
                
                {/*<Grid item xs={12} sm={6} md={4} lg={3}>
                    <ActionCard 
                        title={t('helpers.coupons')} 
                        subtitle="Mis descuentos activos"
                        icon={faGifts} 
                        color={cardColors.purple}
                        onClick={() => redirect('coupons')}
                    />
                </Grid>*/}

                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <ActionCard 
                        title={t('helpers.reservations')} 
                        subtitle="Citas y Agendamientos"
                        icon={faCalendarAlt} 
                        color={cardColors.orange}
                        onClick={() => redirect('reservations')}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <ActionCard 
                        title={t('helpers.tickets')} 
                        subtitle="Entradas a eventos"
                        icon={faTicket} 
                        color={cardColors.green}
                        onClick={() => redirect('tickets')}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4} lg={3}>
                    <ActionCard 
                        title="Suscripciones" 
                        subtitle="Membresías activas"
                        icon={faIdCard} 
                        color={cardColors.teal}
                        onClick={() => redirect('subscriptions')}
                    />
                </Grid>
            </Grid>

            {/* --- 3. CATEGORIES SECTION (Reutilizamos tu componente mejorado) --- */}
            <Categories />
        </Box>
    );
}